"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
class Div extends fmko_ts_common_1.Widget {
    constructor(text) {
        super();
        this.element = document.createElement("div");
        if (typeof text === "string") {
            this.setText(text);
        }
    }
    getHTML() {
        return this.element.innerHTML;
    }
    getText() {
        return this.element.innerText;
    }
    getTextContent() {
        return this.element.textContent;
    }
    setHTML(html) {
        this.element.innerHTML = fmko_ts_common_1.HTMLUtils.sanitizeHTML(html);
    }
    setText(text) {
        this.element.innerText = text;
    }
    setTextContent(text) {
        this.element.textContent = text;
    }
}
exports.default = Div;
//# sourceMappingURL=Div.js.map